<template>
	<a-drawer title="账号报价变更申请详情" width="70%" :closable="true" :visible="visibleEdit" @close="onClose">
		<div style="width: 80%;margin:0 auto;padding-bottom: 30px;">
			<div style="float: right;">
				<Approval @success="success" v-if="!notApprovalStateArr.includes(accountPriceApply.applyStatus)" :brokerApprovalOpinion="brokerApprovalOpinion" :type="approvalType" :uuid="accountPriceApply.uuid"/>
			</div>
		</div>
		<div style="width: 80%;margin:30px auto">
		    <div>
				<a-steps>
				    <a-step :status="item.status" :title="item.title" :description="item.description" v-for="(item,index) in accountPriceApply.stepList" :key="index">
				        <a-icon :type="item.type" slot="icon" style="font-size:24px;"/>
				    </a-step>
				</a-steps>
			</div>
			<div style="margin-top: 20px;">
				<UserTaskRecord :businessType="'account'" :uuid="accountPriceApply.uuid"></UserTaskRecord>
			</div>
		</div>
		<a-divider>申请信息</a-divider>
		<a-form :form="form" style="width: 80%;margin:30px auto">
			<a-form-item labelAlign="left" label="申请标题" v-bind="formItemLayout">
				{{accountPriceApply.title}}
			</a-form-item>
			<a-form-item labelAlign="left" v-if="canEdit" label="申请备注" v-bind="formItemLayout">
				<a-input type="textarea"style="width: 100%;" v-model="brokerApprovalOpinion" placeholder="请录入申请备注" />
			</a-form-item>
			<a-form-item labelAlign="left" v-if="!canEdit && accountPriceApply.brokerApprovalOpinion" label="申请备注" v-bind="formItemLayout">
				{{accountPriceApply.brokerApprovalOpinion}}
			</a-form-item>
		</a-form>
		<div style="width: 80%;margin:20px auto" class="formItemLayoutBackground">
			<PlatformAccountInfo :accountPriceApply="accountPriceApply" ></PlatformAccountInfo>
			<WeiboPrice :accountPriceApply="accountPriceApply" :canEdit="canEdit"></WeiboPrice>
			<WeiboCollectionPrice :accountPriceApply="accountPriceApply" :canEdit="canEdit"></WeiboCollectionPrice>
			<WeixinPrice :accountPriceApply="accountPriceApply" :canEdit="canEdit"></WeixinPrice>
			<DouyinPrice :accountPriceApply="accountPriceApply" :canEdit="canEdit"></DouyinPrice>
			<BilibiliPrice :accountPriceApply="accountPriceApply" :canEdit="canEdit"></BilibiliPrice>
			<RedbookPrice :accountPriceApply="accountPriceApply" :canEdit="canEdit"></RedbookPrice>
			<MomentsPrice :accountPriceApply="accountPriceApply" :canEdit="canEdit"></MomentsPrice>
			<KuaishouPrice :accountPriceApply="accountPriceApply" :canEdit="canEdit"></KuaishouPrice>
			<ChannelsPrice :accountPriceApply="accountPriceApply" :canEdit="canEdit"></ChannelsPrice>
			<div style="margin-top: 10px;">
				*注：不同颜色代表不同报价调整类型，
				<span style="background-color: beige;">淡黄色</span>原价格，
				<span style="background-color: yellow;">黄色</span>修改，
				<span style="background-color: palegreen;">绿色</span>新增，
				<span style="background-color: orangered;">红色</span>删除。
			</div>
		</div>
	</a-drawer>
</template>

<script>
	import WeiboPrice from './weiboPrice';
	import WeiboCollectionPrice from './weiboCollectionPrice';
	import WeixinPrice from './weixinPrice';
	import DouyinPrice from './douyinPrice';
	import BilibiliPrice from './bilibiliPrice';
	import RedbookPrice from './redbookPrice';
	import MomentsPrice from './momentsPrice';
	import KuaishouPrice from './kuaishouPrice';
	import ChannelsPrice from './channelsPrice';
	import Approval from './approval';
	import UserTaskRecord from './userTaskRecord';
	import PlatformAccountInfo from './platformAccountInfo';

	const formItemLayout = {
		labelCol: {
			span: 2
		},
		wrapperCol: {
			span: 22
		}
	}
	export default {
		props: {
			visibleEdit: {
				default: false
			},
		},
		components:{
			WeiboPrice,
			WeiboCollectionPrice,
			WeixinPrice,
			DouyinPrice,
			BilibiliPrice,
			RedbookPrice,
			MomentsPrice,
			KuaishouPrice,
			ChannelsPrice,
			Approval,
			UserTaskRecord,
			PlatformAccountInfo
		},
		data() {
			return {
				formItemLayout,
				form: this.$form.createForm(this),
				id: null,
				dialog: false,
				loading: false,
				accountPriceApply: {},
				notApprovalStateArr: ['team_leader_resubmit','audit_resubmit'],
				approvalType: 'account',
				brokerApprovalOpinion: ''
			}
		},
		computed:{
			canEdit() {
				return this.accountPriceApply.canEdit;
			}
		},
		methods: {
			setFormValues({ ...item}) {
				this.id = item.id;
				this.brokerApprovalOpinion = '';
				this.getById();
			},
			getById(){
				this.accountPriceApply = {};
				this.$get("accountPriceApply/getById",{id: this.id}).then(res => {
					this.accountPriceApply = res.data;
					if(this.accountPriceApply.platformType == "weibo" ||  this.accountPriceApply.platformType == "channels"){
						let arr = [];
						if (this.accountPriceApply.enterPlatformType != null && this.accountPriceApply.enterPlatformType != '') {
							this.accountPriceApply.enterPlatformType.split(",").forEach(e => {
								arr.push(e);
							})
						}
						this.accountPriceApply.enterPlatformType = arr;
					}
				});
			},
			onClose() {
				this.form.resetFields();
				this.$emit('close')
			},
			success() {
				this.$emit('success')
			},
		},
	}
</script>
<style lang="less" scoped>
	.formItemLayoutBackground{
		/deep/.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content{
			background-color: #fff !important;
			border: 1px solid #E8E8E8 !important;
		}
		/deep/ table {
			border-left: 1px solid black !important;
			border-bottom: 1px solid black !important;
		}
		/deep/ table > .ant-table-thead > tr > th {
			border-right: 1px solid black !important;
			border-top: 1px solid black !important;
		}
		/deep/ table > .ant-table-tbody > tr > td {
			border-right: 1px solid black !important;
			border-top: 1px solid black !important;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/account/accountChange/accountPrice/accountPriceApplyView.vue